var objectFitImages = require("object-fit-images");

(function($) {
    objectFitImages("img.img--objectfit");
})(jQuery);
